import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-hero-banner.component.scss';
var DealsHeroBanner = /** @class */ (function (_super) {
    tslib_1.__extends(DealsHeroBanner, _super);
    function DealsHeroBanner(element) {
        return _super.call(this, element) || this;
    }
    DealsHeroBanner.prototype.init = function () {
    };
    DealsHeroBanner.prototype.bindEvents = function () {
    };
    return DealsHeroBanner;
}(Base));
export { DealsHeroBanner };



//////////////////
// WEBPACK FOOTER
// ./components/deals-hero-banner/deals-hero-banner.component.ts
// module id = 661
// module chunks = 0